import { inputAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(inputAnatomy.keys)

  const filled = definePartsStyle({
    field: {
      background: '#DEDEDE',
      // Let's also provide dark mode alternatives
      _dark: {
        borderColor: 'gray.600',
        background: 'gray.800',
      },
    },
  })
  
  export const inputTheme = defineMultiStyleConfig({
    variants: { filled },
  })